import React from "react";

// ============= LEGACY EXPERIMENT IDS (kept for backward compatibility) =============
export const KED_OPT_IN_ALL_EXPERIMENT_ID_1 = "ked-opt-in-all-10-07"

export const KED_OPT_IN_MATURA_PARENT_EXPERIMENT_ID_1 = "ked-opt-in-matura-parent-22-07"
export const KED_OPT_IN_MATURA_PARENT_EXPERIMENT_ID_2 = "ked-opt-in-matura-parent-03-08"
export const KED_OPT_IN_MATURA_PARENT_EXPERIMENT_ID_3 = "ked-opt-in-matura-parent-07-08"
export const KED_SALES_CALL_MATURA_PARENT_EXPERIMENT_ID_1 = "ked-sales-call-matura-parent-22-07"

export const KED_MATURA_PARENT_DIRECT_EXPERIMENT_ID_1 = "ked-direct-matura-parent-22-08"

export const MW_EXPERIMENT_ID_1 = "mw-10-09"
export const MW_STUDENT_EXPERIMENT_ID_1 = "mw-student-10-09"

export const FB_ADS_DIRECT_EXPERIMENT_ID_1 = "fb-ads-direct-04-09"
export const FB_ADS_DIRECT_EXPERIMENT_ID_2 = "fb-ads-direct-18-09"

export const MW_FULL_FUNNEL_EXPERIMENT_1 = "mw-05-10"

export const MW_FULL_FUNNEL_EXPERIMENT_2 = "mw-03-11"


export const KED_WEBINAR_EXPERIMENT_1 = "ked-webinar-1"

export const KED_WEBINAR_EXPERIMENT_AB_1 = "webinar-03-02"

export const KED_WEBINAR_EXPERIMENT_AB_2 = "webinar-06-02"

export const KED_WEBINAR_EXPERIMENT_AB_3 = "webinar-10-02"

export const KED_WEBINAR_EXPERIMENT_AB_4 = "webinar-12-02"

export const KED_WEBINAR_EXPERIMENT_AB_5 = "webinar-16-02"

export const KED_WEBINAR_EXPERIMENT_AB_6 = "webinar-23-02"

export const KED_WEBINAR_EXPERIMENT_AB_7 = "webinar-10-03"

export const KED_WEBINAR_EXPERIMENT_AB_8 = "webinar-13-03"

export const KED_WEBINAR_EXPERIMENT_AB_9 = "webinar-30-03"

export const KED_WEBINAR_EXPERIMENT_AB_10 = "webinar-04-04"

export const KED_WEBINAR_EXPERIMENT_AB_11 = "webinar-05-04"

export const KED_WEBINAR_EXPERIMENT_AB_12 = "webinar-10-04"

export const KED_WEBINAR_EXPERIMENT_AB_13 = "webinar-13-04"

export const KED_WEBINAR_EXPERIMENT_AB_14 = "webinar-16-04"

export const KED_WEBINAR_EXPERIMENT_AB_15 = "webinar-17-04"

export const KED_WEBINAR_EXPERIMENT_AB_16 = "webinar-01-05"

export const KED_WEBINAR_EXPERIMENT_AB_17 = "webinar-06-05"

export const KED_WEBINAR_EXPERIMENT_AB_18 = "webinar-17-05"

export const KED_WEBINAR_EXPERIMENT_AB_19 = "webinar-22-05"

export const KED_WEBINAR_EXPERIMENT_AB_20 = "webinar-28-05"

export const KED_WEBINAR_EXPERIMENT_AB_21 = "webinar-05-06"

export const KED_WEBINAR_EXPERIMENT_AB_22 = "webinar-19-06"

export const KED_WEBINAR_EXPERIMENT_AB_23 = "webinar-05-07"

export const KED_WEBINAR_EXPERIMENT_AB_24 = "webinar-12-07"

export const KED_WEBINAR_EXPERIMENT_AB_25 = "webinar-16-07"

export const KED_WEBINAR_EXPERIMENT_AB_26 = "webinar-20-07"

export const KED_WEBINAR_EXPERIMENT_AB_27 = "webinar-24-07"

export const KED_WEBINAR_EXPERIMENT_AB_28 = "webinar-29-07"

export const KED_WEBINAR_EXPERIMENT_AB_29 = "webinar-04-08"

export const KED_WEBINAR_EXPERIMENT_AB_30 = "webinar-14-08"

export const KED_WEBINAR_EXPERIMENT_AB_31 = "webinar-31-08"

export const KED_WEBINAR_EXPERIMENT_AB_32 = "webinar-07-09"

export const KED_WEBINAR_EXPERIMENT_AB_33 = "webinar-11-09"

export const KED_WEBINAR_EXPERIMENT_AB_34 = "webinar-14-09"

export const KED_WEBINAR_EXPERIMENT_AB_35 = "webinar-21-09"

export const KED_WEBINAR_EXPERIMENT_AB_36 = "webinar-02-10"

export const KED_WEBINAR_EXPERIMENT_AB_37 = "webinar-05-10"

export const KED_WEBINAR_EXPERIMENT_AB_38 = "webinar-14-10"

export const KED_WEBINAR_EXPERIMENT_AB_39 = "webinar-27-10"

export const KED_WEBINAR_EXPERIMENT_AB_40 = "webinar-03-11"

export const KED_WEBINAR_EXPERIMENT_AB_41 = "webinar-09-11"

export const KED_WEBINAR_EXPERIMENT_AB_42 = "webinar-08-12"

export const KED_WEBINAR_EXPERIMENT_AB_43 = "webinar-17-12"

export const KED_WEBINAR_EXPERIMENT_AB_44 = "webinar-18-12"

export const KED_WEBINAR_EXPERIMENT_AB_45 = "webinar-22-12"

export const KED_WEBINAR_EXPERIMENT_AB_46 = "webinar-07-01"

export const KED_WEBINAR_EXPERIMENT_AB_47 = "webinar-12-01"

export const KED_WEBINAR_EXPERIMENT_AB_48 = "webinar-20-01"

export const KED_WEBINAR_EXPERIMENT_AB_49 = "webinar-27-01"

export const KED_WEBINAR_EXPERIMENT_AB_50 = "webinar-10-02-26"

export const KED_WEBINAR_EXPERIMENT_AB_51 = "webinar-09-03-26"

export const KED_WEBINAR_EXPERIMENT_AB_52 = "webinar-12-03-26"

export const KED_WEBINAR_EXPERIMENT_AB_53 = "webinar-22-03-26"

export const KED_WEBINAR_EXPERIMENT_AB_54 = "webinar-25-03-26"

export const KED_WEBINAR_EXPERIMENT_AB_55 = "webinar-30-03-26"

export const KED_WEBINAR_EXPERIMENT_AB_56 = "webinar-31-03-26"

export const KED_WEBINAR_EXPERIMENT_AB_57 = "webinar-03-04-26"

export const KED_WEBINAR_EXPERIMENT_AB_58 = "webinar-04-04-26"

export const KED_WEBINAR_EXPERIMENT_AB_59 = "webinar-21-04-26"

export const KED_WEBINAR_EXPERIMENT_AB_60 = "webinar-27-04-26"

export const KED_WEBINAR_EXPERIMENT_AB_61 = "webinar-05-05-26"

export const KED_WEBINAR_EXPERIMENT_AB_62 = "webinar-06-05-26"

export const KED_WEBINAR_EXPERIMENT_AB_63 = "webinar-13-05-26"


// ============= SAAS EXPERIMENTS HISTORY =============
export const SAAS_EXPERIMENT_AB_1 = "saas-28-08"

// ============= ACTIVE EXPERIMENTS (Only 2 active at a time) =============
// For students - accessed via /platforma
export const ACTIVE_SAAS_STUDENT_EXPERIMENT = "saas-student-28-08"

// For parents - accessed via /platforma-rodzic  
export const ACTIVE_SAAS_PARENT_EXPERIMENT = "saas-parent-28-08"

// Ebook landing page experiment
export const LAUNCH_LANDING_EXPERIMENT = "ebook-10-02"

// SMS content experiment - tracking clicks from short SMS links
export const SMS_CONTENT_EXPERIMENT = "sms-content"

// English webinar experiment.
// `DEFAULT_EN_EXPERIMENT` is the *trace/analytics* experiment id — it tags every trace
// (PageLoad, EnteredEmail, etc.) and feeds the "🌍 EN Webinar Experiments" admin panel.
// The webinar record's `WebinarExperimentId` is set independently by the backend
// (`webinarService.createWebinarDetails`), so bumping this constant rolls metrics over
// to a fresh bucket without breaking automation triggers like `..._en-webinar-2_A`.
export const EN_WEBINAR_EXPERIMENT_1 = "en-webinar-1"
export const EN_WEBINAR_EXPERIMENT_2 = "en-webinar-2"
export const EN_WEBINAR_EXPERIMENT_3 = "en-webinar-3"
export const EN_WEBINAR_EXPERIMENT_4 = "en-webinar-4"
export const DEFAULT_EN_EXPERIMENT = EN_WEBINAR_EXPERIMENT_4

// Legacy DEFAULT_EXPERIMENT for backward compatibility (webinar experiments).
// Each app may override via REACT_APP_DEFAULT_EXPERIMENT env var (inlined at build).
export const DEFAULT_EXPERIMENT = process.env.REACT_APP_DEFAULT_EXPERIMENT || KED_WEBINAR_EXPERIMENT_AB_63

export const DEFAULT_EXPERIMENT_V1 = `${DEFAULT_EXPERIMENT}-v1`
export const DEFAULT_EXPERIMENT_V2 = `${DEFAULT_EXPERIMENT}-v2`
export const DEFAULT_EXPERIMENT_V3 = `${DEFAULT_EXPERIMENT}`
export const DEFAULT_EXPERIMENT_V4 = `${DEFAULT_EXPERIMENT}-v4`

// ============= HELPER FUNCTIONS =============
export interface OptInProps {
    handleButtonClick: (buttonNum: number, variation: ("A" | "B")) => void
    confirmModalOpen: boolean
    setConfirmModalOpen: React.Dispatch<React.SetStateAction<boolean>>
    loading: boolean
    isInputValid: boolean
    email: string
    setEmail: React.Dispatch<React.SetStateAction<string>>
    name: string
    setName: React.Dispatch<React.SetStateAction<string>>
}

export function getExperimentVariation(experimentId: string) {
    const key = `ab-variation-${experimentId}`;

    // Priority 1: Check URL parameters (highest priority - explicit from ads/links)
    const urlParams = new URLSearchParams(window.location.search);
    const urlVariation = urlParams.get(key);

    if (urlVariation) {
        return urlVariation;
    }

    // Fallback for legacy 'variation' parameter
    const fallbackKey = 'variation';
    const fallbackVariation = urlParams.get(fallbackKey);

    if (fallbackVariation) {
        return fallbackVariation;
    }

    // Priority 2: Check cookies (source of truth from Lambda@Edge)
    const cookieVariation = getCookieValue(key);

    if (cookieVariation) {
        return cookieVariation;
    }

    return "unknown";
}

// Helper function to read cookies
function getCookieValue(name: string): string | null {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.trim().split('=');
        if (cookieName === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    return null;
}

export async function getSourceAndVariationFromRequest(request: Request, experimentId: string): Promise<{
    source: string,
    variation: string
}> {
    const queryString = request.url.split('?').length > 1 ? request.url.split('?')[1] : '';
    const searchParams = new URLSearchParams(queryString);

    const source = searchParams.get('source') ?? 'unknown'

    // Priority 1: Check URL parameter
    const key = `ab-variation-${experimentId}`;
    let variation = searchParams.get(key);

    // Priority 2: Check cookies if not in URL (using the existing getCookieValue function)
    if (!variation) {
        variation = getCookieValue(key);
    }

    // Fallback to 'unknown' if not found in either
    variation = variation ?? 'unknown';

    return {source, variation}
}